import { render, staticRenderFns } from "./OverviewKpis.vue?vue&type=template&id=2800b252&scoped=true&"
import script from "./OverviewKpis.vue?vue&type=script&lang=js&"
export * from "./OverviewKpis.vue?vue&type=script&lang=js&"
import style0 from "./OverviewKpis.vue?vue&type=style&index=0&id=2800b252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800b252",
  null
  
)

export default component.exports